function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useAction } from 'hooks';
import App, { AlertsBus } from 'modules/App';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import JoinOrCreate from './JoinOrCreate';
import OrganizationBox from './OrganizationBox';
const Memberships = ()=>{
    const organizationMemberships = useSelector(selectors.organizationMemberships);
    return /*#__PURE__*/ _jsx("section", {
        className: "section section--transparent mt-7",
        children: organizationMemberships.map((organizationMembership)=>/*#__PURE__*/ _jsx(OrganizationBox, {
                organizationMembership: organizationMembership
            }, `${organizationMembership.identityUID}-${organizationMembership.organizationUID}`))
    });
};
const OrganizationMemberships = ()=>{
    const onFetchOrganizationMemberships = useAction(actions.fetchOrganizationMemberships);
    useEffect(()=>{
        onFetchOrganizationMemberships();
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("header", {
                className: "pageHeader",
                children: /*#__PURE__*/ _jsx("h1", {
                    className: "text--h1",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.headers.organizations))
                })
            }),
            /*#__PURE__*/ _jsx(AlertsBus, {
                className: "section section--transparent my-5"
            }),
            /*#__PURE__*/ _jsx(Memberships, {}),
            /*#__PURE__*/ _jsx(JoinOrCreate, {})
        ]
    });
};
export default OrganizationMemberships;
